type IconThreadsProps = {
    className?: string;
};

export function IconThreads(props: IconThreadsProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2525_2766)">
                <path
                    d="M17.6921 11.8267C17.5887 11.7771 17.4837 11.7294 17.3774 11.6838C17.1921 8.2704 15.327 6.31625 12.1952 6.29625C12.181 6.29616 12.1669 6.29616 12.1528 6.29616C10.2795 6.29616 8.72164 7.09574 7.76275 8.55071L9.48512 9.73223C10.2014 8.64541 11.3257 8.41372 12.1536 8.41372C12.1631 8.41372 12.1727 8.41372 12.1822 8.41381C13.2134 8.42039 13.9915 8.7202 14.4951 9.30488C14.8616 9.73054 15.1067 10.3188 15.2281 11.0611C14.3139 10.9057 13.3251 10.8579 12.2681 10.9185C9.29059 11.09 7.37639 12.8266 7.50495 15.2396C7.57019 16.4636 8.17996 17.5166 9.22188 18.2045C10.1028 18.786 11.2374 19.0704 12.4165 19.006C13.9738 18.9206 15.1954 18.3265 16.0476 17.2401C16.6949 16.4151 17.1042 15.346 17.285 13.9989C18.0271 14.4467 18.5771 15.0361 18.8809 15.7446C19.3974 16.949 19.4275 18.9281 17.8126 20.5416C16.3978 21.9551 14.697 22.5666 12.1267 22.5855C9.27552 22.5644 7.11922 21.65 5.71726 19.8678C4.40444 18.1989 3.72596 15.7884 3.70065 12.7031C3.72596 9.61785 4.40444 7.20732 5.71726 5.53846C7.11922 3.75624 9.27549 2.84188 12.1266 2.82069C14.9985 2.84204 17.1924 3.7608 18.648 5.55162C19.3618 6.42982 19.8999 7.53423 20.2546 8.82191L22.273 8.2834C21.843 6.6984 21.1664 5.33259 20.2456 4.19988C18.3795 1.90396 15.6503 0.727519 12.1337 0.703125H12.1196C8.6102 0.727434 5.91151 1.90835 4.09854 4.21304C2.48524 6.26393 1.65305 9.11759 1.62509 12.6947L1.625 12.7031L1.62509 12.7116C1.65305 16.2886 2.48524 19.1424 4.09854 21.1933C5.91151 23.4979 8.6102 24.6789 12.1196 24.7031H12.1337C15.2538 24.6815 17.453 23.8646 19.2647 22.0545C21.6351 19.6864 21.5637 16.718 20.7825 14.8958C20.222 13.589 19.1534 12.5276 17.6921 11.8267ZM12.3051 16.8915C11.0001 16.965 9.6443 16.3793 9.57745 15.1246C9.5279 14.1944 10.2395 13.1564 12.3851 13.0327C12.6309 13.0185 12.872 13.0116 13.1089 13.0116C13.8883 13.0116 14.6174 13.0873 15.2802 13.2323C15.033 16.32 13.5828 16.8214 12.3051 16.8915Z"
                    fill={'black'}
                />
            </g>
            <defs>
                <clipPath id="clip0_2525_2766">
                    <rect width="24" height="24" fill={'black'} transform="translate(0 0.703125)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconThreads;
